// A successful count may be zero. Missing or invalid measurements stay unknown.
export const measuredCount = value => Number.isSafeInteger(value) && value >= 0 ? value : null;

export function sapCountMeasurement(counts, hours, key) {
  return counts?.source === "sap-count" ? counts.buckets?.[hours]?.[key] || null : null;
}

export function sapCountDescription(measurement, t, locale) {
  if (!measurement) return "";
  const time = typeof measurement.measuredAt === "number" ? measurement.measuredAt
    : typeof measurement.measuredAt === "string" ? Date.parse(measurement.measuredAt) : NaN;
  if (measuredCount(measurement.value) === null || !Number.isFinite(time) || time <= 0) {
    return t("errorMonitorCosts:notice.notMeasured");
  }
  return t(measurement.stale ? "errorMonitorCosts:notice.countStaleAt" : "errorMonitorCosts:notice.countMeasuredAt", {
    time: new Intl.DateTimeFormat(locale, { dateStyle: "medium", timeStyle: "medium" }).format(time),
  });
}
